import { render, staticRenderFns } from "./LMSDashboard.vue?vue&type=template&id=0b07a1e9&"
import script from "./LMSDashboard.vue?vue&type=script&lang=js&"
export * from "./LMSDashboard.vue?vue&type=script&lang=js&"
import style0 from "./LMSDashboard.vue?vue&type=style&index=0&id=0b07a1e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports